import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { SocketProvider } from './contexts/SocketContext';
import { StripeProvider } from './contexts/StripeContext';
import ProtectedRoute from './components/ProtectedRoute';

// Public Pages
import Landing from './pages/Landing';
import WorkerLogin from './pages/auth/WorkerLogin';
import RestaurantLogin from './pages/auth/RestaurantLogin';
import WorkerRegister from './pages/auth/WorkerRegister';
import RestaurantRegister from './pages/auth/RestaurantRegister';
import AdminLogin from './pages/auth/AdminLogin';

// Dashboard Pages
import WorkerDashboard from './pages/worker/WorkerDashboard';
import RestaurantDashboard from './pages/restaurant/RestaurantDashboard';
import AdminDashboard from './pages/admin/AdminDashboard';

// Profile Pages
import WorkerProfile from './pages/worker/WorkerProfile';
import RestaurantProfile from './pages/restaurant/RestaurantProfile';

// Checkout Pages
import CheckoutShiftPayment from './pages/checkout/CheckoutShiftPayment';
import CheckoutWorkerPro from './pages/checkout/CheckoutWorkerPro';
import CheckoutRestaurantUnlimited from './pages/checkout/CheckoutRestaurantUnlimited';
import PaymentSuccess from './pages/checkout/PaymentSuccess';

// 404
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <LanguageProvider>
          <SocketProvider>
            <StripeProvider>
              <div className="min-h-screen">
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<Landing />} />
                  <Route path="/worker-login" element={<WorkerLogin />} />
                  <Route path="/restaurant-login" element={<RestaurantLogin />} />
                  <Route path="/worker-register" element={<WorkerRegister />} />
                  <Route path="/restaurant-register" element={<RestaurantRegister />} />

                  {/* Admin Routes */}
                  <Route path="/admin-login" element={<AdminLogin />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />

                  {/* Worker Protected Routes */}
                  <Route path="/dashboard/worker" element={
                    <ProtectedRoute requiredUserType="worker">
                      <WorkerDashboard />
                    </ProtectedRoute>
                  } />
                  <Route path="/profile/worker" element={
                    <ProtectedRoute requiredUserType="worker">
                      <WorkerProfile />
                    </ProtectedRoute>
                  } />

                  {/* Restaurant Protected Routes */}
                  <Route path="/dashboard/restaurant" element={
                    <ProtectedRoute requiredUserType="restaurant">
                      <RestaurantDashboard />
                    </ProtectedRoute>
                  } />
                  <Route path="/profile/restaurant" element={
                    <ProtectedRoute requiredUserType="restaurant">
                      <RestaurantProfile />
                    </ProtectedRoute>
                  } />

                  {/* Checkout Routes (Protected) */}
                  <Route path="/checkout/shift-payment" element={
                    <ProtectedRoute requiredUserType="restaurant">
                      <CheckoutShiftPayment />
                    </ProtectedRoute>
                  } />
                  <Route path="/checkout/worker-pro" element={
                    <ProtectedRoute requiredUserType="worker">
                      <CheckoutWorkerPro />
                    </ProtectedRoute>
                  } />
                  <Route path="/checkout/restaurant-unlimited" element={
                    <ProtectedRoute requiredUserType="restaurant">
                      <CheckoutRestaurantUnlimited />
                    </ProtectedRoute>
                  } />
                  <Route path="/payment-success" element={
                    <ProtectedRoute>
                      <PaymentSuccess />
                    </ProtectedRoute>
                  } />

                  {/* 404 - Catch all unmatched routes */}
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </div>
            </StripeProvider>
          </SocketProvider>
        </LanguageProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
